import { render, staticRenderFns } from "./CopyTo.vue?vue&type=template&id=78b5e6b7&"
import script from "./CopyTo.vue?vue&type=script&lang=js&"
export * from "./CopyTo.vue?vue&type=script&lang=js&"
import style0 from "./CopyTo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports